// export default function getSearchFilters(data) {
//   if (!data) return
//   const parsedData = JSON.parse(data)
//   const filters = {
//     current_title: { mustHave: [], mustNotHave: [] },
//     expertise: { mustHave: [], mustNotHave: [] },
//     degree: { mustHave: [], mustNotHave: [] },
//     certifications: { mustHave: [], mustNotHave: [] },
//     current_company: { mustHave: [], mustNotHave: [] },
//     current_industry: { mustHave: [], mustNotHave: [] },
//     career_count: { mustHave: [], mustNotHave: [] },
//     career_length: { mustHave: [], mustNotHave: [] },
//     postCode: { mustHave: '' },
//     distance: { mustHave: '' },
//     locations: { mustHave: [] },
//     languages: { mustHave: [], mustNotHave: [] }
//   }
//   const mustHave = parsedData.mustHave
//   const mustNotHave = parsedData.mustNotHave

//   const shouldHave = parsedData.shouldHave

//   for (const keys in mustHave) {
//     if (filters[keys]) {
//       filters[keys].mustHave = parsedData.mustHave[keys]
//     }
//   }

//   for (const keys in mustNotHave) {
//     if (filters[keys]) {
//       filters[keys].mustNotHave = parsedData.mustNotHave[keys]
//     }
//   }

//   for (const keys in shouldHave) {
//     if (filters[keys]) {
//       filters[keys].shouldHave = parsedData.shouldHave[keys]
//     }
//   }

//   if (mustHave?.location && !mustHave?.locations?.length) {
//     filters.locations.mustHave = [
//       { location: mustHave.location, distance: parsedData?.mustHave?.distance }
//     ]
//   }
//   // eslint-disable-next-line
//   const {
//     current_title,
//     expertise,
//     degree,
//     certifications,
//     current_company,
//     current_industry,
//     career_length,
//     career_count,
//     locations,
//     postCode,
//     distance,
//     languages
//   } = filters

//   return {
//     title: { current_title },
//     skills: { expertise },
//     education: { degree, certifications },
//     company: { company: current_company, industry: current_industry },
//     experience: { years: career_length, count: career_count },
//     location: { locations },
//     postCode: { postCode },
//     distance,
//     languages
//   }
// }

export default function getSearchFilters(data) {
  if (!data) return
  const parsedData = JSON.parse(data)
  const filters = {
    current_title: { mustHave: [], mustNotHave: [] },
    expertise: { mustHave: [], mustNotHave: [] },
    degree: { mustHave: [], mustNotHave: [] },
    certifications: { mustHave: [], mustNotHave: [] },
    current_company: { mustHave: [], mustNotHave: [] },
    current_industry: { mustHave: [], mustNotHave: [] },
    career_count: { mustHave: [], mustNotHave: [] },
    career_length: { mustHave: [], mustNotHave: [] },
    postCode: { mustHave: '' },
    distance: { mustHave: '' },
    locations: { mustHave: [] },
    languages: { mustHave: [], mustNotHave: [] }
  }

  const mustHave = parsedData.mustHave || {}
  const mustNotHave = parsedData.mustNotHave || {}
  const shouldHave = parsedData.shouldHave || {}

  // Map API keys to local keys
  const keyMap = {
    company: 'current_company',
    industry: 'current_industry'
  }

  // Assign mustHave
  for (const key in mustHave) {
    const mappedKey = keyMap[key] || key
    if (filters[mappedKey]) {
      filters[mappedKey].mustHave = mustHave[key]
    }
  }

  // Assign mustNotHave
  for (const key in mustNotHave) {
    const mappedKey = keyMap[key] || key
    if (filters[mappedKey]) {
      filters[mappedKey].mustNotHave = mustNotHave[key]
    }
  }

  // Assign shouldHave
  for (const key in shouldHave) {
    const mappedKey = keyMap[key] || key
    if (filters[mappedKey]) {
      filters[mappedKey].shouldHave = shouldHave[key]
    }
  }

  // Special case for location
  if (mustHave?.location && !mustHave?.locations?.length) {
    filters.locations.mustHave = [
      { location: mustHave.location, distance: parsedData?.mustHave?.distance }
    ]
  }

  // Return structured filters
  const {
    current_title,
    expertise,
    degree,
    certifications,
    current_company,
    current_industry,
    career_length,
    career_count,
    locations,
    postCode,
    distance,
    languages
  } = filters

  return {
    title: { current_title },
    skills: { expertise },
    education: { degree, certifications },
    company: { company: current_company, industry: current_industry },
    experience: { years: career_length, count: career_count },
    location: { locations },
    postCode: { postCode },
    distance,
    languages
  }
}
